import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {ActionLink} from '@travel-frontend/ui-components';

export const ToggleCollapse = styled.div`
  ${({theme}) => css`
    ${ActionLink} {
      ${theme.typography.labelSmallBold}
    }
  `};
`;
